import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableContent from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckDrawers/TableContent';
import { getVehicleTrackingLineItemQualityCheckLog } from 'src/redux/Actions/VehicleTracking';
import Table from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckDrawers/Table';

export default function CreateQcProductDrawer({
  setDrawerOpen,
  vehicleTrackingNumber,
  qualityCheckId,
  setDrawerStep,
  formData,
  setFormData,
}) {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;

  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { vehicleTrackingLineItemQualityCheckList } = vehicleTrackingReducer;
  const vehicleTrackingList = vehicleTrackingLineItemQualityCheckList;

  useEffect(() => {
    dispatch(
      getVehicleTrackingLineItemQualityCheckLog(
        tenantOrganisationId,
        qualityCheckId,
        vehicleTrackingNumber,
      ),
    );
  }, [dispatch, tenantOrganisationId, qualityCheckId, vehicleTrackingNumber]);

  const tableHeaders = [
    { label: 'PO Number', value: 'po_number' },
    { label: 'invoice Number', value: 'invoice_number' },
    { label: 'Products', value: 'product_sap_code' },
    { label: 'Receiving Quantity', value: 'receiving_quantity' },
    { label: 'Quantity', value: 'quantity' },
  ];

  return (
    <div className="page-layout div-flex-column rg-10">
      <div className="div-flex-row horizontal-padding-16 border-bottom div-space-between div-align-center padding-bottom-8">
        <span className="text-xxl text-bold">Step 1: Select Product</span>
      </div>
      <Table
        headers={tableHeaders}
        minCellWidth={10}
        tableContent={
          <TableContent
            headers={tableHeaders}
            vehicleTrackingList={vehicleTrackingList}
            formData={formData}
            setFormData={setFormData}
          />
        }
      />
      <div className="div-space-between horizontal-padding-16 border-top footer-content-for-page">
        <button
          className={`common-btn-outlined theme-border-color-${themeColor}`}
          onClick={() => setDrawerOpen(false)}
        >
          Cancel
        </button>
        <div className="div-flex-row">
          <button
            className={`vehicle-tracking-detail-move-stage-btn div-align-center theme-background-${themeColor}`}
            onClick={() => setDrawerStep('step2')}
          >
            <span className="text-sm">Proceed</span>
          </button>
        </div>
      </div>
    </div>
  );
}
